import axios from "axios";
import API from "../helpers/api";

const defaultSearchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 15,
};

export const getStaffList = (item) => {
  const url = `${API.getShipStaffs}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getStaffListSuccess",
          data: response.data,
        });
      })
      .catch(() => {
        dispatch({
          type: "getStaffListFailure",
          error: "ERROR",
        });
      });
  };
};

export const postStaffDetails = (data) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const url = `${API.postShipStaff}`;
  return (dispatch) => {
    axios
      .post(url, data, {
        headers: {
          key: currentUser.accessToken,
        },
      })
      .then((response) => {
        dispatch(getStaffList(defaultSearchData));
        dispatch({
          type: "postStaffDetailSuccess",
          data: response.data,
        });
      })
      .catch(() => {
        dispatch({
          type: "postStaffDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const putStaffDetails = (data, searchData = defaultSearchData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const url = `${API.putShipStaff}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: currentUser.accessToken,
        },
      })
      .then((response) => {
        dispatch(getStaffList(searchData));
        dispatch({
          type: "putStaffDetailSuccess",
          data: response.data,
        });
      })
      .catch(() => {
        dispatch({
          type: "putStaffDetailFailure",
          error: "ERROR",
        });
      });
  };
};
